<template>
  <div class="backgroud-white cs-homework-basic" v-loading="isLoading">
    <el-row class="cs-homework-basic-header">
      <el-col :span="12" class="cs-homework-name cs-homework-title">
        <span class="cs-homework-title-item">{{ model.name}}</span>
        <homeworkStatus class="cs-homework-title-item" v-if="showStatus" :data="homeworkStatusData"></homeworkStatus>
      </el-col>

      <el-col :span="12" v-if="canEdit">
        <a class="cs-homework-edit" @click="editHomework(model)">编辑</a>
      </el-col>
    </el-row>

    <div>
      <el-form ref="model" class="cs-homework-basicInfo" :model="model" label-width="100px">
        <!-- <el-form-item label="对应课节" prop="courseActivationName">
          <div>{{model.courseActivationName}}</div>
        </el-form-item> -->
        <el-form-item label="周" prop="courseActivationName">
          <div>{{model.weekDescription}}</div>
        </el-form-item>

        <el-form-item label="完成要求" prop="homeworkType">
          <el-tag size="mini" v-if="model.homeworkType==1" class="need-complate">要求完成</el-tag>

          <el-tag size="mini" v-if="model.homeworkType==2" class="practice">仅供练习</el-tag>
        </el-form-item>

        <el-form-item label="创建时间" prop="createTime">
          <div>{{model.createTime}}</div>
        </el-form-item>

        <el-form-item label="截止时间" prop="endTime">
          <div>{{model.endTime}}</div>
        </el-form-item>
        <el-form-item label="状态" prop="endTime">
          <div>
            <span :class="{'open':!isHomeworkEnd}">{{!isHomeworkEnd?'开放':'已关闭'}}</span>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      width="600px"
      :visible.sync="dialogEditorVisible"
      top="8vh"
    >
      <homeworkEditor :data="editData" @closeDialog="onCloseEditor" @saveSuccess="onSaveSuccess"></homeworkEditor>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>
.cs-homework-basic {
  .open {
    color: #185626;
  }
  .cs-homework-basic-header {
    margin-bottom: 1rem;
  }
  .cs-homework-name {
    padding-right: 10px;
    text-align: right;
  }
  .cs-homework-edit {
    color: #409eff;
    cursor: pointer;
    line-height: 2rem;
  }
  /deep/ .el-form-item__label {
    color: black;
    font-weight: normal;
    margin: 0;
    line-height: 22px;
  }
  .cs-homework-basicInfo {
    /deep/ .el-form-item__content {
      line-height: 22px;
      vertical-align: middle;
    }
  }
  .el-form-item {
    margin-bottom: 10px;
  }
  .need-complate {
    background-color: #d5edda;
    color: #185626;
    border: 1pt solid #acd4b6;
    font-size: 10px;
  }
  .practice {
    background-color: #dbeffb;
    color: #2e74b6;
    border: 1pt solid #a9c2e3;
    font-size: 10px;
  }
  .cs-homework-title-item{
    margin-right: 5px;
    display: inline;
  }
}
</style>

<script>
import homeworkEditor from "./homeworkEditor";
import homeworkStatus from "./homeworkStatus";
import {
  getHomeworkTypes,
  getCourseHomeworkDetail
} from "../../service/homework.service";

export default {
  props: {
    data: {
      courseId: Number,
      homeworkId: Number,
      campusId: Number,
      homeworkStatus: Number,
      homeworkStatusText: String
    },
    canEdit: Boolean,
    showStatus: Boolean
  },
  data() {
    return {
      isLoading: false,
      editData: {},
      dialogEditorVisible: false,
      isHomeworkEnd: false,
      homeworkTypes: {},
      homeworkStatusData: {},
      model: {
        id: 0,
        name: "",
        courseId: 0,
        courseName: "",
        //courseActivationName: "",
        week: 0,
        weekDescription: "",
        homeworkType: 0,
        endTime: "",
        createTime: "",
        files: []
      }
    };
  },
  components: {
    homeworkEditor,
    homeworkStatus
  },
  created() {
    getHomeworkTypes().then(result => {
      if (!!result && result.success) {
        this.homeworkTypes = result.data;
      }
    });
    this.initData();
  },
  methods: {
    initData() {
      if (!this.data || !this.data.homeworkId) {
        return;
      }

      if (this.showStatus) {
        this.homeworkStatusData = {
          homeworkStatus: this.data.homeworkStatus,
          homeworkStatusText: this.data.homeworkStatusText
        };
      }

      this.getDetailData();
    },
    getDetailData() {
      this.isLoading = true;
      getCourseHomeworkDetail(this.data.homeworkId)
        .then(result => {
          if (result.success) {
            this.model.id = result.data.Id;
            this.model.name = result.data.Name;
            this.model.campusId = result.data.CampusId;
            this.model.courseId = result.data.CourseId;
            this.model.courseName = result.data.CourseName;
            this.model.courseActivationId = result.data.CourseActivationId;
            //this.model.courseActivationName = result.data.CourseActivationName;
            this.model.week = result.data.Week;
            this.model.weekDescription = result.data.WeekDescription;
            this.model.homeworkType = result.data.HomeworkType;
            this.model.endTime = result.data.EndTimeString;
            this.model.createTime = result.data.CreateTime;
            this.model.files = result.data.Files;
            this.isHomeworkEnd = result.data.IsHomeworkEnd;
          }
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    editHomework() {
      this.editData = {
        Id: this.model.id,
        Name: this.model.name,
        CourseId: this.model.courseId,
        CourseName: this.model.courseName,
        CourseActivationId: this.model.courseActivationId,
        //CourseActivationName: this.model.courseActivationName,
        Week: this.model.week,
        HomeworkType: this.model.homeworkType,
        EndTimeString: this.model.endTime,
        CreateTime: this.model.createTime,
        Files: _.clone(this.model.files)
      };
      this.dialogEditorVisible = true;
    },
    onCloseEditor() {
      this.dialogEditorVisible = false;
    },
    onSaveSuccess(isAdd, row) {
      this.dialogEditorVisible = false;
      this.getDetailData();
      this.$emit("saveInfo");
    }
  },
  watch: {
    data: function() {
      this.initData();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/homework/homeworkBasicInfor.vue